import React, { useState } from 'react';
import { useConnection } from '@/contexts/ConnectionContext';
import { useOffline } from '@/hooks/useOffline';
import { ChevronDownIcon, ChevronUpIcon, XMarkIcon } from '@heroicons/react/24/outline';

const ConnectionDebug: React.FC = () => {
  const { isOnline, lastChecked, method } = useConnection();
  const { isOfflineMode, offlineData } = useOffline();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 bg-black bg-opacity-75 text-white rounded-lg text-xs font-mono z-50 shadow-lg">
      {/* Header avec boutons de contrôle */}
      <div className="flex items-center justify-between p-2 border-b border-gray-600">
        <span className="text-xs font-bold">🔍 Statut Connexion</span>
        <div className="flex items-center space-x-1">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="p-1 hover:bg-gray-600 rounded transition-colors"
            title={isExpanded ? 'Réduire' : 'Développer'}
          >
            {isExpanded ? (
              <ChevronDownIcon className="h-3 w-3" />
            ) : (
              <ChevronUpIcon className="h-3 w-3" />
            )}
          </button>
          <button
            onClick={() => setIsVisible(false)}
            className="p-1 hover:bg-gray-600 rounded transition-colors"
            title="Fermer"
          >
            <XMarkIcon className="h-3 w-3" />
          </button>
        </div>
      </div>

      {/* Contenu détaillé */}
      {isExpanded && (
        <div className="p-3 space-y-1">
          <div>🌐 Internet: {isOnline ? '✅' : '❌'}</div>
          <div>🔄 Mode Offline: {isOfflineMode ? '✅' : '❌'}</div>
          <div>📊 Pending: {offlineData.pendingChanges}</div>
          <div>⏰ Last Check: {lastChecked.toLocaleTimeString()}</div>
          <div>🔍 Method: {method}</div>
          <div>🎯 Effective: {isOnline && !isOfflineMode ? 'En ligne' : 'Hors ligne'}</div>
        </div>
      )}

      {/* Version réduite */}
      {!isExpanded && (
        <div className="p-2">
          <div className="flex items-center space-x-2">
            <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-400' : 'bg-red-400'}`} />
            <span>{isOnline ? 'En ligne' : 'Hors ligne'}</span>
            {offlineData.pendingChanges > 0 && (
              <span className="bg-red-500 px-1 rounded text-xs">
                {offlineData.pendingChanges}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConnectionDebug;
